import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import TabModule from '../store/tab.store';
import login from '../store/modules/login';
import user from '../store/modules/user';
import SystemSetting from '../store/modules/systemSetting.store';
import role from '../store/modules/role';
import permission from '../store/modules/permission';
import organizationRole from '../store/modules/organizationRole';
import educationDegree from '../store/modules/educationDegree';
import province from '../store/modules/province';
import city from '../store/modules/city';
import hospital from '../store/modules/hospital';
import hospitalFence from '@/store/modules/hospitalFence.store.js';
import drugVehicleType from '../store/modules/drugVehicleType.store';
import service from '../store/modules/service';
import userPersonnelInfo from '../store/modules/userPersonnelInfo';
import zone from '../store/modules/zone';
import station from '../store/modules/station';
import cancelReason from '../store/modules/cancelReason';
import dispatchCode from '../store/modules/dispatchCode';
import flagData from '../store/modules/flagData';
import otherOrganization from '../store/modules/otherOrganization';
import preDefinedNote from '../store/modules/preDefinedNote';
import extension from '../store/modules/extension';
import typeOfUrgency from '../store/modules/appInformation/typeOfUrgency';
import clinicalTriage from '../store/modules/clinicalTriage';
import airAmbulance from '../store/modules/airAmbulance';
import publicData from '../store/modules/publicData';

// chief-complaint
import chiefComplaint from '../store/modules/chiefComplaint/index';
import chiefComplaintAnswer from '../store/modules/chiefComplaint/answer';
import chiefComplaintQuestion from '../store/modules/chiefComplaint/question';
import generalTriageQuestion from '../store/modules/generalTriageQuestion';
import chiefComplaintAttachment from '../store/modules/chiefComplaint/attachment';
import triageQuestion from '../store/modules/triageQuestion';
import triageAnswer from '../store/modules/triageAnswer';
// training
import training from '../store/modules/training';
// 800
import recent800Calls from '../store/modules/800/recentCall.store';
import Notifications800 from '@/store/modules/800/notification.store';
import user800Notifications from '@/store/modules/800/userNotification.store';
import unit from '../store/modules/unit';
import orderType from '../store/modules/orderType';
import drugGroup from '../store/modules/drugGroup';
import vehicleType from '../store/modules/vehicleType';
import drug from '../store/modules/drug';
import chiefComplaintAdvice from '../store/modules/chiefComplaint/advice';
import disabledPeople from '../store/modules/disabledPeople';
import vehicle from '../store/modules/vehicle';
import phone from '../store/modules/phone';
import userGroup from '../store/modules/userGroup';
import userGridSettings from '../store/modules/userGridSettings.js';
import medicalItem from '../store/modules/medicalItem';
import tag from '../store/modules/tag';
import theme from '../store/modules/theme';
import call from '../store/modules/call';
import mission from './modules/mission';
import map from './modules/map';
import missionPhone from './modules/missionPhone';
import callTag from './modules/callTag';
import missionState from './modules/missionState';
import missionNote from './modules/missionNote';
import missionAddressLog from './modules/missionAddressLog';
import phoneOnlineLocation from './modules/phoneOnlineLocation';
import missionLackOfCode from './modules/missionLackOfCode';
import stationFence from './modules/stationFence';
import stationCoverageZone from './modules/stationCoverageZone';
import stationCoverageZoneSupportStation from './modules/stationCoverageZoneSupportStation';
import outOfServicePhone from './modules/outOfServicePhone';
import outOfServiceHospital from './modules/outOfServiceHospital';
import diagnosisBaseData from './modules/diagnosisBaseData';
import patient from './modules/patient';
import patientDoctorDetail from './modules/patientDoctorDetail';
import generalAction from './modules/generalAction';
import abdomenExamination from './modules/abdomenExamination';
import airway from './modules/airway';
import bloodCirculation from './modules/bloodCirculation';
import chestPainDuration from './modules/chestPainDuration';
import chestPainLocation from './modules/chestPainLocation';
import chestPainPropagation from './modules/chestPainPropagation';
import chestPainType from './modules/chestPainType';
import consciousnessLevel from './modules/consciousnessLevel';
import doctorConsultationType from './modules/doctorConsultationType';
import fetalPosition from './modules/fetalPosition';
import headacheIllnessHistory from './modules/headacheIllnessHistory';
import headacheLocation from './modules/headacheLocation';
import headacheOtherSign from './modules/headacheOtherSign';
import headacheOtherSpecification from './modules/headacheOtherSpecification';
import headacheType from './modules/headacheType';
import heartRhythm from './modules/heartRhythm';
import heartSound from './modules/heartSound';
import pulseRhythm from './modules/pulseRhythm';
import respiration from './modules/respiration';
import respiratorySound from './modules/respiratorySound';
import resuscitationType from './modules/resuscitationType';
import skinExamination from './modules/skinExamination';
import skinTemperature from './modules/skinTemperature';
import skinTurgor from './modules/skinTurgor';
import vertigoAggravatingFactor from './modules/vertigoAggravatingFactor';
import vertigoDuration from './modules/vertigoDuration';
import vertigoOtherSpecification from './modules/vertigoOtherSpecification';
import vertigoType from './modules/vertigoType';
import pulseQuality from './modules/pulseQuality';
import patientInitialAssessment from './modules/patientInitialAssessment';
import patientDetail from './modules/patientDetail';
import patientVitalSign from './modules/patientVitalSign';
import patientAccompanyingSymptom from './modules/patientAccompanyingSymptom';
import patientMedicalHistory from './modules/patientMedicalHistory';
import patientDrugHistory from './modules/patientDrugHistory';
import patientAllergyHistory from './modules/patientAllergyHistory';
import patientMedicalExamination from './modules/patientMedicalExamination';
import patientBodyExamination from './modules/patientBodyExamination';
import patientTechnicianDrug from './modules/patientTechnicianDrug';
import patientMedicalItem from './modules/patientMedicalItem';
import patientGeneralAction from './modules/patientGeneralAction';
import patientResult from './modules/patientResult';
import clientComputer from './modules/clientComputer';
import report from './modules/report';
import hospitalAdmission from './modules/hospitalAdmission';
import dashboard from './modules/dashboard';
import missionOtherOrganizationRequest from './modules/missionOtherOrganizationRequest';
import missionOtherOrganizationInform from './modules/missionOtherOrganizationInform';
import surveyCategory from './modules/surveyCategory';
import checkList from './modules/checkList';
import userDND from './modules/userDND';
import geographicalType from './modules/geographicalType';
import resultBaseData from './modules/resultBaseData';
import missionOtherOrganization from './modules/missionOtherOrganization';
import customReport from './modules/customReport';
import terminehStore from './modules/termineh.store';
import recursiveFieldStore from './modules/recursiveField.store';
export default new Vuex.Store({
  state: {
    cancelTokens(state) {
      return state.cancelTokens;
    },
  },
  getters: {
    cancelTokens(state) {
      return state.cancelTokens;
    },
  },
  mutations: {
    ADD_CANCEL_TOKEN(state, token) {
      state.cancelTokens.push(token);
    },
    CLEAR_CANCEL_TOKENS(state) {
      state.cancelTokens = [];
    },
  },
  actions: {
    CANCEL_PENDING_REQUESTS(context) {
      context.state.cancelTokens.forEach((request) => {
        if (request.cancel) {
          request.cancel();
        }
      });
      context.commit('CLEAR_CANCEL_TOKENS');
    },
  },
  modules: {
    airAmbulanceModule: airAmbulance,
    publicDataModule: publicData,
    TabModule,
    loginModule: login,
    userModule: user,
    SystemSettingModule: SystemSetting,
    roleModule: role,
    permissionModule: permission,
    organizationRoleModule: organizationRole,
    educationDegreeModule: educationDegree,
    provinceModule: province,
    cityModule: city,
    hospitalModule: hospital,
    hospitalFenceModule: hospitalFence,
    serviceModule: service,
    userPersonnelInfoModule: userPersonnelInfo,
    zoneModule: zone,
    stationModule: station,
    cancelReasonModule: cancelReason,
    dispatchCodeModule: dispatchCode,
    flagDataModule: flagData,
    otherOrganizationModule: otherOrganization,
    preDefinedNoteModule: preDefinedNote,
    extensionModule: extension,
    typeOfUrgencyModule: typeOfUrgency,
    chiefComplaintModule: chiefComplaint,
    chiefComplaintAnswerModule: chiefComplaintAnswer,
    chiefComplaintQuestionModule: chiefComplaintQuestion,
    chiefComplaintAttachmentModule: chiefComplaintAttachment,
    generalTriageQuestionModule: generalTriageQuestion,
    triageQuestionModule: triageQuestion,
    triageAnswerModule: triageAnswer,
    trainingModule: training,
    drugVehicleTypeModule: drugVehicleType,
    unitModule: unit,
    orderTypeModule: orderType,
    drugGroupModule: drugGroup,
    vehicleTypeModule: vehicleType,
    drugModule: drug,
    clinicalTriageModule: clinicalTriage,
    chiefComplaintAdviceModule: chiefComplaintAdvice,
    disabledPeopleModule: disabledPeople,
    vehicleModule: vehicle,
    phoneModule: phone,
    userGroupModule: userGroup,
    userGridSettingsModule: userGridSettings,
    medicalItemModule: medicalItem,
    tagModule: tag,
    themeModule: theme,
    callModule: call,
    missionModule: mission,
    mapModule: map,
    missionPhoneModule: missionPhone,
    callTagModule: callTag,
    missionStateModule: missionState,
    missionNoteModule: missionNote,
    // 800
    recent800CallsModule: recent800Calls,
    Notifications800Module: Notifications800,
    UserNotifications800Module: user800Notifications,
    missionAddressLogModule: missionAddressLog,
    phoneOnlineLocationModule: phoneOnlineLocation,
    missionLackOfCodeModule: missionLackOfCode,
    stationFenceModule: stationFence,
    stationCoverageZoneModule: stationCoverageZone,
    stationCoverageZoneSupportStationModule: stationCoverageZoneSupportStation,
    outOfServicePhoneModule: outOfServicePhone,
    outOfServiceHospitalModule: outOfServiceHospital,
    diagnosisBaseDataModule: diagnosisBaseData,
    patientModule: patient,
    patientDoctorDetailModule: patientDoctorDetail,
    generalActionModule: generalAction,
    abdomenExaminationModule: abdomenExamination,
    airwayModule: airway,
    bloodCirculationModule: bloodCirculation,
    chestPainDurationModule: chestPainDuration,
    chestPainLocationModule: chestPainLocation,
    chestPainPropagationModule: chestPainPropagation,
    chestPainTypeModule: chestPainType,
    consciousnessLevelModule: consciousnessLevel,
    doctorConsultationTypeModule: doctorConsultationType,
    fetalPositionModule: fetalPosition,
    headacheIllnessHistoryModule: headacheIllnessHistory,
    headacheLocationModule: headacheLocation,
    headacheOtherSignModule: headacheOtherSign,
    headacheOtherSpecificationModule: headacheOtherSpecification,
    headacheTypeModule: headacheType,
    heartRhythmModule: heartRhythm,
    heartSoundModule: heartSound,
    pulseRhythmModule: pulseRhythm,
    respirationModule: respiration,
    respiratorySoundModule: respiratorySound,
    resuscitationTypeModule: resuscitationType,
    skinExaminationModule: skinExamination,
    skinTemperatureModule: skinTemperature,
    skinTurgorModule: skinTurgor,
    vertigoAggravatingFactorModule: vertigoAggravatingFactor,
    vertigoDurationModule: vertigoDuration,
    vertigoOtherSpecificationModule: vertigoOtherSpecification,
    vertigoTypeModule: vertigoType,
    pulseQualityModule: pulseQuality,
    patientInitialAssessmentModule: patientInitialAssessment,
    patientDetailModule: patientDetail,
    patientVitalSignModule: patientVitalSign,
    patientAccompanyingSymptomModule: patientAccompanyingSymptom,
    patientMedicalHistoryModule: patientMedicalHistory,
    patientDrugHistoryModule: patientDrugHistory,
    patientAllergyHistoryModule: patientAllergyHistory,
    patientMedicalExaminationModule: patientMedicalExamination,
    patientBodyExaminationModule: patientBodyExamination,
    patientTechnicianDrugModule: patientTechnicianDrug,
    patientMedicalItemModule: patientMedicalItem,
    patientGeneralActionModule: patientGeneralAction,
    patientResultModule: patientResult,
    clientComputerModule: clientComputer,
    reportModule: report,
    hospitalAdmissionModule: hospitalAdmission,
    dashboardModule: dashboard,
    missionOtherOrganizationRequestModule: missionOtherOrganizationRequest,
    missionOtherOrganizationInformModule: missionOtherOrganizationInform,
    surveyCategoryModule: surveyCategory,
    checkListModule: checkList,
    userDNDModule: userDND,
    geographicalTypeModule: geographicalType,
    resultBaseDataModule: resultBaseData,
    missionOtherOrganizationModule: missionOtherOrganization,
    customReportModule: customReport,
    terminehModule: terminehStore,
    recursiveFieldModule: recursiveFieldStore,
  },
});
